import { CheckCircle2, RefreshCw } from 'lucide-react';
import { useAppUpdate } from '../hooks/useAppUpdate';
import { useT } from '../hooks/useT';
import { APP_BUILD, APP_VERSION } from '../utils/version';

/** Versienummer met build, en in het menu ook of er een nieuwe versie klaarstaat (met knop om te vernieuwen). */
export function VersionInfo() {
  const { t, tf } = useT();
  const { updateAvailable, update } = useAppUpdate();

  return (
    <div className="space-y-3">
      <p className="text-sm text-slate-600 dark:text-slate-400">
        {tf('versionLabel', { version: APP_VERSION })} · {tf('versionBuild', { build: APP_BUILD })}
      </p>
      {updateAvailable ? (
        <button
          onClick={update}
          className="flex min-h-11 items-center gap-2 whitespace-nowrap rounded-2xl bg-indigo-700 px-4 text-sm font-semibold text-white transition-all duration-150 active:scale-95"
        >
          <RefreshCw size={18} aria-hidden /> {t('updateAvailable')} · {t('updateNow')}
        </button>
      ) : (
        <p className="flex items-center gap-2 text-sm text-slate-600 dark:text-slate-400">
          <CheckCircle2 size={18} aria-hidden /> <span className="whitespace-nowrap">{t('upToDate')}</span>
        </p>
      )}
    </div>
  );
}
